"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventInput = exports.VcMetadata = exports.VerificationMetadata = exports.VerificationInvalidReason = exports.EventName = exports.EventComponent = exports.EventCategory = void 0;
var EventCategory;
(function (EventCategory) {
    EventCategory["DID"] = "DID";
    EventCategory["VC"] = "VC";
    EventCategory["VP"] = "VP";
    EventCategory["APPLICATION"] = "APPLICATION";
})(EventCategory = exports.EventCategory || (exports.EventCategory = {}));
var EventComponent;
(function (EventComponent) {
    EventComponent["AffinityWalletExpoSDK"] = "AffinityWalletExpoSDK";
    EventComponent["AffinidiRegistry"] = "AffinidiRegistry";
    EventComponent["AffinidiBrowserSDK"] = "AffinidiBrowserWalletSDK";
    EventComponent["AffinidiExpoSDK"] = "AffinidiExpoWalletSDK";
    EventComponent["AffinidiReactNativeSDK"] = "AffinidiReactNativeWalletSDK";
    EventComponent["AffinidiCloudAPI"] = "AffinidiCloudWalletAPI";
    EventComponent["AffinidiOnboarding"] = "AffinidiOnboarding";
    EventComponent["AffinidiCommon"] = "AffinidiCommon";
    EventComponent["AffinidiCore"] = "AffinidiCore";
    EventComponent["AffinidiRevocation"] = "AffinidiRevocation";
    // TODO: application-level component should be retired eventually
    EventComponent["AffinidiCaregiver"] = "AffinidiCaregiver";
    EventComponent["AffinidiHealthPassVerifier"] = "AffinidiHealthPassVerifier";
    EventComponent["NotImplemented"] = "NotImplemented";
})(EventComponent = exports.EventComponent || (exports.EventComponent = {}));
var EventName;
(function (EventName) {
    EventName["DID_CREATED"] = "Did Created";
    EventName["DID_UPDATED"] = "Did Updated";
    EventName["VC_VERIFIED"] = "VC Verified";
    EventName["VC_VERIFIED_PER_PARTY"] = "VC Verified per party";
    EventName["VC_SAVED"] = "VC Saved";
    EventName["VC_SIGNED"] = "VC Signed";
    EventName["VC_REVOKED"] = "VC Revoked";
    EventName["VP_SIGNED"] = "VP Signed";
    EventName["VP_VERIFIED"] = "VP Verified";
    EventName["VP_SIGNED_JWT"] = "VP Signed JWT";
    EventName["VP_VERIFIED_JWT"] = "VP Verified JWT";
    EventName["USER_ONBOARDED"] = "User Onboarded";
})(EventName = exports.EventName || (exports.EventName = {}));
var VerificationInvalidReason;
(function (VerificationInvalidReason) {
    VerificationInvalidReason["REVOKED"] = "VC/VP has been revoked";
    VerificationInvalidReason["HOLDER_MISMATCHED"] = "Given holder doesn't match the VC/VP holder";
    VerificationInvalidReason["JWT_EXPIRED"] = "JWT token is expired";
    VerificationInvalidReason["JWT_INVALID_SIGNATURE"] = "JWT token signature is invalid";
    VerificationInvalidReason["JWT_NONCE_MISMATCHED"] = "JWT token nonce doesn't match";
    VerificationInvalidReason["JWT_VERIFIER_MISMATCHED"] = "The verifier who verified the VP is not the one who requested for it";
    VerificationInvalidReason["JWT_HOLDER_MISMATCHED"] = "The holder who sent the VP is not the one specified by verifier in the original request";
    VerificationInvalidReason["ERROR"] = "An error occurred during verification (refer to the error message for details)";
})(VerificationInvalidReason = exports.VerificationInvalidReason || (exports.VerificationInvalidReason = {}));
class VerificationMetadata {
}
exports.VerificationMetadata = VerificationMetadata;
class VcMetadata {
}
exports.VcMetadata = VcMetadata;
class EventInput {
}
exports.EventInput = EventInput;
//# sourceMappingURL=shared.dto.js.map